const naiveUiComponents = [
  'NConfigProvider',
  'NInput',
  'NDatePicker',
  'NSpace',
  'NFormItem',
  'NInputNumber',
  'NForm',
  'NButton',
  'NButtonGroup',
  'NSelect',
  'NRadio',
  'NRadioGroup',
  'NSwitch',
]

const loaded = ref(false)

const registerGlobalComponents = async (vueApp: any) => {
  // no tree shaking here, so we import the full library
  // TODO: manually import esm components
  const naiveUIModule = (await import('naive-ui')) as any
  const components = naiveUiComponents.map(
    (componentName) => naiveUIModule[componentName]
  )

  import('naive-ui').then((mod) => {
    const naive = mod.create({ components })
    vueApp.use(naive)
  })
}

export const useNaiveUi = () => {
  const load = async (vueApp: any) => {
    if (loaded.value) {
      return
    }
    await registerGlobalComponents(vueApp)
    loaded.value = true
  }

  return { load }
}
